module.exports = __webpack_public_path__ + "media/src/assets/Images/LogoPdf-7961a799adc9cba9a7747731c9373378.png";